import { createContext } from 'react'

import { createAreaTreeStore } from '../store/createStore'

export const AreaTreeStoreContext = createContext<
  ReturnType<typeof createAreaTreeStore> | undefined
>(undefined)
